var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C9.01631 23.25 6.15471 22.0649 4.04492 19.9551C1.93514 17.8453 0.750001 14.9837 0.750001 12C0.750001 9.01631 1.93514 6.1547 4.04492 4.04492C6.15471 1.93514 9.01632 0.749999 12 0.749999C14.9837 0.749999 17.8453 1.93514 19.9551 4.04492C22.0649 6.15471 23.25 9.01631 23.25 12C23.25 14.9837 22.0649 17.8453 19.9551 19.9551C17.8453 22.0649 14.9837 23.25 12 23.25Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18L16 12L10 6",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextActive);
export default __webpack_public_path__ + "static/media/next-active.4b7fa843f7b467e0cf1db6e73817b463.svg";
export { ForwardRef as ReactComponent };